import {injectable} from 'inversify';

import type {ApiCountResponse} from '../../../../../api/types';
import type {BNUserFormsAnswersCountParams} from '../../../../../api/types/bnrks/methods';
import type {
  FetchMissedCromsCountQuery,
  QueryParams,
} from '../FetchMissedCromsCount.query';

import {apiRequest} from '../../../../../api/utils/apiRequest';
import {logger} from '../../../../../utils/logger';

@injectable()
export class FetchMissedCromsCountQueryJrpc
  implements FetchMissedCromsCountQuery
{
  async fetchCount({userId}: QueryParams = {}): Promise<number> {
    const query: BNUserFormsAnswersCountParams['query'] = [
      ['answered', '==', null],
    ];

    if (userId) {
      query.push(['user_id', '==', userId]);
    }

    try {
      const {_count}: ApiCountResponse =
        await apiRequest<BNUserFormsAnswersCountParams>({
          method: 'user.forms.answers.count',
          params: {query},
        });

      return _count;
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}
